module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Podstawowe dane")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Twoja nazwa grupy",
      "name": "name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.item.name = $$v
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "account",
      "label": "Konto do wysłania wiadomości przy zapisywaniu się do tej grupy",
      "options": _vm.accounts,
      "placeholder": "Wybierz konto",
      "required": ""
    },
    model: {
      value: (_vm.item.email_account_id),
      callback: function($$v) {
        _vm.item.email_account_id = $$v
      },
      expression: "item.email_account_id"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "status",
      "label": "Status",
      "options": _vm.statuses,
      "placeholder": "Wybierz status",
      "required": ""
    },
    model: {
      value: (_vm.item.status),
      callback: function($$v) {
        _vm.item.status = $$v
      },
      expression: "item.status"
    }
  }), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "public"
    },
    model: {
      value: (_vm.item.public),
      callback: function($$v) {
        _vm.item.public = $$v
      },
      expression: "item.public"
    }
  }, [_vm._v("Grupa publiczna")])], 1), _vm._v(" "), (_vm.item.public) ? _c('fieldset', [_c('legend', [_vm._v("Formularz zapisywania się")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tytuł",
      "name": "form_title",
      "type": "text",
      "placeholder": "Wpisz tytuł formularza"
    },
    model: {
      value: (_vm.item.form_title),
      callback: function($$v) {
        _vm.item.form_title = $$v
      },
      expression: "item.form_title"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tekst przycisku",
      "name": "form_submit_btn",
      "type": "text",
      "placeholder": "Wpisz tekst przycisku"
    },
    model: {
      value: (_vm.item.form_submit_btn),
      callback: function($$v) {
        _vm.item.form_submit_btn = $$v
      },
      expression: "item.form_submit_btn"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Dodatkowa treść nad formularzem",
      "name": "form_html_body",
      "type": "text",
      "multi-line": true,
      "rows": 4,
      "placeholder": "Wpisz dodatkową treść"
    },
    model: {
      value: (_vm.item.form_html_body),
      callback: function($$v) {
        _vm.item.form_html_body = $$v
      },
      expression: "item.form_html_body"
    }
  }), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "user_agree"
    },
    model: {
      value: (_vm.item.user_agree),
      callback: function($$v) {
        _vm.item.user_agree = $$v
      },
      expression: "item.user_agree"
    }
  }, [_vm._v("Wymagana zgoda (1)")]), _vm._v(" "), (_vm.item.user_agree) ? _c('div', [_c('ui-textbox', {
    attrs: {
      "label": "Tekst zgody (1)",
      "name": "user_agree_text",
      "type": "text",
      "placeholder": "Wpisz tekst zgody",
      "multi-line": true,
      "rows": 2
    },
    model: {
      value: (_vm.item.user_agree_text),
      callback: function($$v) {
        _vm.item.user_agree_text = $$v
      },
      expression: "item.user_agree_text"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Link z dodatkowymi informacjami (1)",
      "name": "user_agree_url",
      "type": "text",
      "placeholder": "Link z dodatkowymi informacjami"
    },
    model: {
      value: (_vm.item.user_agree_url),
      callback: function($$v) {
        _vm.item.user_agree_url = $$v
      },
      expression: "item.user_agree_url"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tekst linku z dodatkowymi informacjami (1)",
      "name": "user_agree_label",
      "type": "text",
      "placeholder": "Tekst linku z dodatkowymi informacjami"
    },
    model: {
      value: (_vm.item.user_agree_label),
      callback: function($$v) {
        _vm.item.user_agree_label = $$v
      },
      expression: "item.user_agree_label"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "user_agree2"
    },
    model: {
      value: (_vm.item.user_agree2),
      callback: function($$v) {
        _vm.item.user_agree2 = $$v
      },
      expression: "item.user_agree2"
    }
  }, [_vm._v("Wymagana zgoda (2)")]), _vm._v(" "), (_vm.item.user_agree2) ? _c('div', [_c('ui-textbox', {
    attrs: {
      "label": "Tekst zgody (2)",
      "name": "user_agree2_text",
      "type": "text",
      "placeholder": "Wpisz tekst zgody",
      "multi-line": true,
      "rows": 2
    },
    model: {
      value: (_vm.item.user_agree2_text),
      callback: function($$v) {
        _vm.item.user_agree2_text = $$v
      },
      expression: "item.user_agree2_text"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Link z dodatkowymi informacjami (2)",
      "name": "user_agree2_url",
      "type": "text",
      "placeholder": "Link z dodatkowymi informacjami"
    },
    model: {
      value: (_vm.item.user_agree2_url),
      callback: function($$v) {
        _vm.item.user_agree2_url = $$v
      },
      expression: "item.user_agree2_url"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tekst linku z dodatkowymi informacjami (2)",
      "name": "user_agree2_label",
      "type": "text",
      "placeholder": "Tekst linku z dodatkowymi informacjami"
    },
    model: {
      value: (_vm.item.user_agree2_label),
      callback: function($$v) {
        _vm.item.user_agree2_label = $$v
      },
      expression: "item.user_agree2_label"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tekst komunikatu po poprawnym zapisaniu się",
      "name": "success_msg",
      "type": "text",
      "placeholder": "Tekst komunikatu po poprawnym zapisaniu się"
    },
    model: {
      value: (_vm.item.success_msg),
      callback: function($$v) {
        _vm.item.success_msg = $$v
      },
      expression: "item.success_msg"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("E-mail z linkiem potwierdzającym")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "success_signup_template_text",
      "label": "Szablon tekstowy",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_text,
      "placeholder": "Wybierz szablon"
    },
    model: {
      value: (_vm.item.success_signup_template_text),
      callback: function($$v) {
        _vm.item.success_signup_template_text = $$v
      },
      expression: "item.success_signup_template_text"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "success_signup_template_html",
      "label": "Szablon html",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_html,
      "placeholder": "Wybierz szablon"
    },
    model: {
      value: (_vm.item.success_signup_template_html),
      callback: function($$v) {
        _vm.item.success_signup_template_html = $$v
      },
      expression: "item.success_signup_template_html"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Dodatkowa treść",
      "name": "confirm_email_body",
      "type": "text",
      "placeholder": "Wpisz dodatkową treść",
      "multi-line": true,
      "rows": 2
    },
    model: {
      value: (_vm.item.confirm_email_body),
      callback: function($$v) {
        _vm.item.confirm_email_body = $$v
      },
      expression: "item.confirm_email_body"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Strona potwierdzenia adresu e-mail")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "confirm_page_template",
      "label": "Szablon html",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_html,
      "placeholder": "Wybierz szablon"
    },
    model: {
      value: (_vm.item.confirm_page_template),
      callback: function($$v) {
        _vm.item.confirm_page_template = $$v
      },
      expression: "item.confirm_page_template"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c612ee2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email-groups/Form.vue
// module id = 228
// module chunks = 0